import { render, staticRenderFns } from "./ModalidadeContratoForm.vue?vue&type=template&id=197b002c"
import script from "./ModalidadeContratoForm.vue?vue&type=script&lang=js"
export * from "./ModalidadeContratoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports